import { render, staticRenderFns } from "./radio-button.vue?vue&type=template&id=da3a06c4&scoped=true"
import script from "./radio-button.vue?vue&type=script&lang=ts&setup=true"
export * from "./radio-button.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./radio-button.vue?vue&type=style&index=0&id=da3a06c4&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3a06c4",
  null
  
)

export default component.exports